export default "__VITE_ASSET__DhIlyNQ4__"